"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
/* global wagtailConfig */
function createSnippetChooser(id) {
    var chooserElement = jquery_1["default"]('#' + id + '-chooser');
    var docTitle = chooserElement.find('.title');
    var input = jquery_1["default"]('#' + id);
    var editLink = chooserElement.find('.edit-link');
    var chooserBaseUrl = chooserElement.data('chooserUrl');
    /*
    Construct initial state of the chooser from the rendered (static) HTML and arguments passed to
    createSnippetChooser. State is either null (= no document chosen) or a dict of id, string and
    edit_link.
  
    The result returned from the snippet chooser modal (see wagtail.snippets.views.chooser.chosen)
    is a superset of this, and can therefore be passed directly to chooser.setState.
    */
    var state = null;
    if (input.val()) {
        state = {
            id: input.val(),
            edit_link: editLink.attr('href'),
            string: docTitle.text(),
        };
    }
    /* define public API functions for the chooser */
    var chooser = {
        getState: function () { return state; },
        getValue: function () { return state && state.id; },
        setState: function (newState) {
            if (newState) {
                input.val(newState.id);
                docTitle.text(newState.string);
                chooserElement.removeClass('blank');
                editLink.attr('href', newState.edit_link);
            }
            else {
                input.val('');
                chooserElement.addClass('blank');
            }
            state = newState;
        },
        getTextLabel: function (opts) {
            if (!state)
                return null;
            var result = state.string;
            if (opts && opts.maxLength && result.length > opts.maxLength) {
                return result.substring(0, opts.maxLength - 1) + '…';
            }
            return result;
        },
        focus: function () {
            jquery_1["default"]('.action-choose', chooserElement).focus();
        },
        openChooserModal: function () {
            var urlQuery = '';
            if (wagtailConfig.ACTIVE_CONTENT_LOCALE) {
                // The user is editing a piece of translated content.
                // Pass the locale along as a request parameter. If this
                // snippet is also translatable, the results will be
                // pre-filtered by this locale.
                urlQuery = '?locale=' + wagtailConfig.ACTIVE_CONTENT_LOCALE;
            }
            // eslint-disable-next-line no-undef, new-cap
            ModalWorkflow({
                url: chooserBaseUrl + urlQuery,
                // eslint-disable-next-line no-undef
                onload: SNIPPET_CHOOSER_MODAL_ONLOAD_HANDLERS,
                responses: {
                    snippetChosen: function (result) {
                        chooser.setState(result);
                    },
                },
            });
        },
        clear: function () {
            chooser.setState(null);
        },
    };
    jquery_1["default"]('.action-choose', chooserElement).on('click', function () {
        chooser.openChooserModal();
    });
    jquery_1["default"]('.action-clear', chooserElement).on('click', function () {
        chooser.clear();
    });
    return chooser;
}
window.createSnippetChooser = createSnippetChooser;
